import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "elixir",
  extensions: [".ex", ".exs"],
  aliases: ["Elixir", "elixir", "ex"],
  loader: () => import('./elixir.js')
});
